import { Group } from "../../schema/types/group/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const groupHelpers = {
  getUserLinks(group: Group) {
    return (group.memberLinks || []).filter((link) => link.includes("/user/"));
  },
  getServiceaccountLinks(group: Group) {
    return (group.memberLinks || []).filter((link) => link.includes("/serviceaccount/"));
  },
};

export interface GroupTableItem extends Group {
  selfLink: string;
}

interface GetGroupTableItemProps {
  link?: string;
  name?: string;
  item?: Group;
}
export function getGroupTableItem({ link, name, item }: GetGroupTableItemProps): GroupTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "group",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      origin: "default",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "group",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    origin: "default",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
